<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <div class="main-block">
    <div :style="styleScene">
      <div :class="cardClasses">
        <div class="card__face card__face--front">
          <lnurl-item v-bind="notFlippedData" ref="notFlippedItem"></lnurl-item>
        </div>
        <div class="card__face card__face--back">
          <lnurl-item v-bind="flippedData" ref="flippedItem"></lnurl-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * TODO Подумать - где размещать сообщение об ошибке
 * TODO Lnurl & Prepayment - сделать через mixin
 */
import dbg from "debug"
const debug = dbg('lnbig:lnurl')
import LnurlItem from "@/components/LnurlItem"
import QrCode from "@/components/Mixin/QrCode"

export default {
  name: "Lnurl",
  components: { LnurlItem },
  mixins: [QrCode],
  props: {
    lnurl:     String,
    expires:   Number,
    countdown: Number,
    error:     String,
    opened:    Boolean,
  },
  data() {
    debug('data func')
    return {
      flipped: false,
      prevNotFlipppedData: {
        lnurl: this.lnurl,
        expires: this.expires,
        countdown: this.countdown,
        error: this.error,
        opened: this.opened,
      },
      prevFlippedData: null,
    }
  },
  watch: {
    lnurl(newVal, oldVal) {
      debug('lnurl/watch, newVal: %o, oldVal: %o', newVal, oldVal)
      if (newVal !== oldVal)
        this.flipped = ! this.flipped
    },
    flippedData(newVal) {
      debug('flippedData/watch, %o', newVal)
      this.prevFlippedData = newVal
    },
    notFlippedData(newVal) {
      debug('notFlippedData, %o', newVal)
      this.prevNotFlipppedData = newVal
    }
  },
  computed: {
    cardClasses() {
      debug('cardClasses/computed, flipped: %o', this.flipped)
      return {
        'card': true,
        'is-flipped': this.flipped,
      }
    },

    styleScene() {
      return {
        width: this.sizeQrCode + 'px',
        height: this.sizeQrCode + 'px',
        perspective: '600px',
        display: 'inline-block'
      }
    },

    flippedData() {
      // this statement is special for calling of getters first time
      let obj = {
        lnurl: this.lnurl,
        expires: this.expires,
        countdown: this.countdown,
        error: this.error,
        opened: this.opened,
      }

      if (this.flipped)
        return obj
      else
        return this.prevFlippedData
    },

    notFlippedData() {
      // this statement is special for calling of getters first time
      let obj = {
        lnurl: this.lnurl,
        expires: this.expires,
        countdown: this.countdown,
        error: this.error,
        opened: this.opened,
      }

      if (! this.flipped)
        return obj
      else
        return this.prevNotFlipppedData
    },
  },
}
</script>

<style scoped>
.main-block {
  text-align: center;
  display: block;
}

.card {
  width: 100%;
  height: 100%;
  transition: transform 1s;
  transform-style: preserve-3d;
  position: relative;
}

.card.is-flipped {
  transform: rotateY(180deg);
}

.card__face {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.card__face--front {
}

.card__face--back {
  transform: rotateY(180deg);
}
</style>
